import React from "react"
import {Col, Row} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"

import ColHeader from "../styled/ColHeader"
import {StyledRow} from "../styled/MyPerksList"

const RedemptionHeaders: React.FC = () => {
  return (
    <StyledRow>
      <Col smOffset={2} sm={7}>
        <Row>
          <Col sm={7}>
            <ColHeader>
              <Label>
                <FormattedMessage id="perks.components.myPerks.myPerksList.title" />
              </Label>
            </ColHeader>
          </Col>
          <Col sm={2}>
            <ColHeader>
              <Label>
                <FormattedMessage id="perks.components.myPerks.myPerksList.quantity" />
              </Label>
            </ColHeader>
          </Col>
          <Col sm={3}>
            <ColHeader>
              <Label>
                <FormattedMessage id="perks.components.myPerks.myPerksList.redeemed" />
              </Label>
            </ColHeader>
          </Col>
        </Row>
      </Col>
      <Col sm={2}>
        <ColHeader>
          <Label>
            <FormattedMessage id="perks.myPerks.myPerksList.actions" />
          </Label>
        </ColHeader>
      </Col>
    </StyledRow>
  )
}

export default RedemptionHeaders
